import { useEffect } from "react"

import { WheelPicker, type WheelOption } from "@/components/ui/wheel-picker"

interface Props {
  value: string
  onChange: (value: string) => void
}

const HOUR_OPTIONS: WheelOption[] = Array.from({ length: 12 }, (_, i) => ({
  label: String(i + 1),
  value: String(i + 1),
}))
const MINUTE_OPTIONS: WheelOption[] = Array.from({ length: 60 }, (_, i) => ({
  label: String(i).padStart(2, "0"),
  value: String(i),
}))
const PERIOD_OPTIONS: WheelOption[] = [
  { label: "AM", value: "AM" },
  { label: "PM", value: "PM" },
]

const DEFAULT = { hour: "9", minute: "0", period: "AM" }

function parse(value: string) {
  const match = value.match(/^(\d{1,2}):(\d{1,2})\s(AM|PM)$/)
  if (match) return { hour: String(+match[1]), minute: String(+match[2]), period: match[3] }
  return DEFAULT
}

function format({ hour, minute, period }: { hour: string; minute: string; period: string }) {
  return `${hour}:${minute.padStart(2, "0")} ${period}`
}

export function TimeStep({ value, onChange }: Props) {
  // Skip sentinel ("I don't remember") — keep the wheel on its default.
  const parts = value && value !== "unknown" ? parse(value) : DEFAULT

  useEffect(() => {
    if (!value) onChange(format(DEFAULT))
  }, [value, onChange])

  const handleChange = (key: string, next: string) => {
    onChange(format({ ...parts, [key]: next }))
  }

  return (
    <WheelPicker
      columns={[
        { key: "hour", options: HOUR_OPTIONS },
        { key: "minute", options: MINUTE_OPTIONS },
        { key: "period", options: PERIOD_OPTIONS },
      ]}
      value={parts}
      onChange={handleChange}
    />
  )
}
